const initialState = {
  noteList: [],
  filteredNoteList: [],
  isNewNoteOpen: false,
  isNewConferenceNoteOpen: false,
  totalRecord: 0,
  editToggle: false,
  isEditing: false,
  isMinimized: false,
  minimizedTitle: "",
  lastNoteList: [],
  tagList: [],
};

const noteManagement = (state = initialState, action) => {
  switch (action.type) {
    case "FETCH_TAG_LIST": {
      const tagList = action.payload;
      return {
        ...state,
        tagList,
      };
    }
    case "FILTER_NOTES": {
      const filteredNoteList = action.payload.rows;
      const totalRecord = action.payload.count;
      return {
        ...state,
        filteredNoteList: filteredNoteList?.sort((a, b) => {
          return a.updatedAt < b.updatedAt ? 1 : -1;
        }),
        totalRecord,
      };
    }
    case "HANDLE_NEW_NOTE": {
      return { ...state, isNewNoteOpen: action.payload };
    }
    case "HANDLE_NEW_CONFERENCE_NOTE": {
      return { ...state, isNewConferenceNoteOpen: action.payload };
    }
    case "HANDLE_IS_EDITING": {
      return { ...state, isEditing: action.payload };
    }
    case "CREATE_NOTE": {
      const newNote = action.payload;
      let newTag;
      if (newNote.tag.trim() !== "") {
        newTag = newNote.tag;
      }
      return {
        ...state,
        filteredNoteList: [newNote]
          .concat(state.filteredNoteList)
          .sort((a, b) => {
            return a.updatedAt < b.updatedAt ? 1 : -1;
          }),
        totalRecord: state.totalRecord + 1,
      };
    }
    case "EDIT_NOTE": {
      let notesWithoutEdited = state.filteredNoteList.filter(
        (n) => n.id !== action.payload.id
      );
      let filteredNoteList = [...notesWithoutEdited, action.payload].sort(
        (a, b) => {
          return a.updatedAt < b.updatedAt ? 1 : -1;
        }
      );
      return {
        ...state,
        filteredNoteList,
        editToggle: !state.editToggle,
      };
    }
    case "MINIMIZED_NOTE": {
      let result =
        action.payload === undefined ? state.minimizedTitle : action.payload;
      return {
        ...state,
        isMinimized: !state.isMinimized,
        minimizedTitle: result,
      };
    }
    case "DELETE_NOTE": {
      var deletedList = state.filteredNoteList.filter(
        (x) => !action.payload.includes(x.id)
      );
      return {
        ...state,
        filteredNoteList: [...deletedList],
        totalRecord: state.totalRecord - 1,
        editToggle: !state.editToggle,
      };
    }
    case "FETCH_LAST_NOTE_LIST": {
      const noteList = action.payload.rows;
      return {
        ...state,
        lastNoteList: noteList,
      };
    }
    default:
      return state;
  }
};

export default noteManagement;
